module.exports = __webpack_public_path__ + "files/6b1f36e1c5009e37326644d47219c990.png";